module.exports = __webpack_public_path__ + "img/pending.48049fcb.svg";